import Vue from "vue";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import set from "lodash/set";
import remove from "lodash/remove";
import findIndex from "lodash/findIndex";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import unset from "lodash/unset";
mixin(_, {
  chain,
  set: set,
  unset,
  remove,
  findIndex,
  keyBy,
  mapValues
});
_.value = value;
_.prototype.value = value;

export default {
  bindMap(state, map) {
    state.map = map;
  },
  setToken(state, token) {
    state.token = token.slice();
    localStorage.accesstoken = token.slice();
  },
  setSrid(state, srid) {
    state.srid = srid;
    localStorage.srid = srid;
  },
  setCurrentZoom(state, zoom) {
    state.zoom = zoom;
  },
  setErrorMessage(state, msg) {
    state.errorMessage = msg;
  },
  setCurrentCoordSystem(state, system) {
    state.currentCoordSystem = system;
    localStorage.currentCoordSystem = system;
  },
  setCurrentBookmark(state, name) {
    state.currentBookmark = name;
  },
  addModal(state, modal) {
    state.activeModals.push(modal);
  },
  removeModal(state, modal) {
    state.activeModals.splice(state.activeModals.indexOf(modal), 1);
  },
  setMapCenter(state, position) {
    state.mapCenter = position;
    localStorage.mapposition = JSON.stringify(position);
  },
  setBookmarks(state, bookmarks) {
    state.bookmarks = bookmarks.slice();
  },
  setUsername(state, username) {
    state.username = username.slice();
    localStorage.username = username.slice();
  },
  setUser(state, user) {
    state.user = user;
  },
  setCurrentUserId(state, uid) {
    state.currentUserId = uid;
  },
  setDicts(state, dicts) {
    state.dicts = dicts;
  },
  setLayers(state, layers) {
    state.layers = layers;
  },
  setLayer(state, layer) {
    state.layer = layer;
  },
  setAppLayers(state, layers) {
    state.appLayers = layers;
  },
  setUserLayers(state, layers) {
    state.userLayers = layers;
  },
  setUserRasterLayers(state, layers) {
    state.userRasterLayers = layers;
  },
  addUserLayer(state, layer) {
    state.userLayers.push(layer)
  },
  addUserRasterLayers(state, layer) {
    state.userRasterLayers.push(layer);
  },
  setAppLayersMeta(state, appLayersMeta) {
    state.appLayersMeta = appLayersMeta;
  },
  setUserLayer(state, props) {
    const idx = _.findIndex(state.userLayers, (ul) => ul.table === props.table);
    Vue.set(state.userLayers, idx, props.layer);
  },
  addTempLayer(state, layer) {
    state.tempLayers.push(layer);
  },

  addWMSLayer(state, layer) {
    state.wmsLayers.push(layer);
  },
  setCurrentEditedLayer(state, currentEditedLayer) {
    state.currentEditedLayer = currentEditedLayer;
  },
  setVisibleLayer(state, props) {
    Vue.set(state.visibleLayers, props.layer, props.visible);
  },
  setLayerInstance(state, props) {
    Vue.set(state.layersInstance, props.layer, props.instance);
  },
  saveVisibleLayers(state) {
    localStorage.layersStack = JSON.stringify(state.visibleLayers);
  },
  setBaselayers(state, baselayers) {
    state.baselayers = baselayers;
  },
  setBasemapOpacity(state, opacity) {
    state.basemapOpacity = opacity;
    localStorage.basemapOpacity = JSON.stringify(state.basemapOpacity);
  },
  setSketches(state, sketches) {
    state.sketches = sketches;
  },
  setSocket(state, socket) {
    state.socket = socket;
  },

  setCurrentBasemap(state, basemap) {
    state.currentBasemap = basemap;
    localStorage.basemap = basemap;
  },

  setStyles(state, styles) {
    state.styles = styles;
    localStorage.layers_styles = JSON.stringify(state.styles);
  },
  setSingleStyles(state, [key, styles]) {
    _.set(state.styles, key, styles);
    state.styles.__ob__.dep.notify(); //hask na powiadomienie odbiorców
    localStorage.layers_styles = JSON.stringify(state.styles);
  },
  removeSingleStyles(state, key) {
    _.unset(state.styles, key);
    state.styles.__ob__.dep.notify(); //hask na powiadomienie odbiorców
    localStorage.layers_styles = JSON.stringify(state.styles);
  },
  setLabelsShow(state, value) {
    state.labelsShow = value;
    localStorage.labelsshow = JSON.stringify(value);
  },
  setShowDirectionFlows(state, value) {
    state.showDirectionFlows = value;
  },
  setShowValvesState(state, value) {
    state.showValvesState = value;
  },
  setValvesStateLegend(state, value) {
    state.valvesStateLegend = value;
    localStorage.valvesStateLegend = JSON.stringify(value);
  },

  setHydrants(state, hydrants) {
    state.hydrants = hydrants;
  },
  setCurrentEditedDict(state, dict) {
    state.currentEditedDict = dict;
  },
  setDictForLayer(state, dict) {
    state.dictForLayer = dict;
  },
  setInspectionTasks(state, inspectionTasks) {
    state.inspectionTasks = inspectionTasks;
  },
  setSelectedHydrants(state, selectedHydrants) {
    state.selectedHydrants = selectedHydrants;
  },
  addSelectedHydrants(state, selectedHydrants) {
    state.selectedHydrants = [...state.selectedHydrants, ...selectedHydrants];
  },
  setSelectedHydrantsEdited(state, selectedHydrantsEdited) {
    state.selectedHydrantsEdited = selectedHydrantsEdited;
  },
  addSelectedHydrantsEdited(state, selectedHydrantsEdited) {
    state.selectedHydrantsEdited = [...state.selectedHydrantsEdited, ...selectedHydrantsEdited];
  },
  setInspectionTask(state, inspectionTask) {
    state.inspectionTask = inspectionTask;
  },
  setNewFieldLayer(state, newFieldLayer) {
    state.newFieldLayer = newFieldLayer;
  },
  setNewFieldDict(state, newFieldDict) {
    state.newFieldDict = newFieldDict;
  },
  setHydrantData(state, hydrantData) {
    state.hydrantData = hydrantData;
  },
  setInspectionCards(state, inspectionCards) {
    state.inspectionCards = inspectionCards;
  },
  setHydrantInspectionCard(state, hydrantInspectionCard) {
    state.hydrantInspectionCard = hydrantInspectionCard;
  },
  setMapActiveLayers(state, layers) {
    // sets array with IDs of visible layers
    state.mapActiveLayers = layers;
  },
  setMapActiveBaselayer(state, layer) {
    state.mapActiveBaselayer = layer;
  },
  setTerminals(state, terminals) {
    state.terminals = terminals;
  },
  setTerminalData(state, terminalData) {
    state.terminalData = terminalData;
  },
  setCurrentSelectedFeatures(state, selectedFeatures) {
    state.selectedFeatures = selectedFeatures;
  },
  addCurrentSelectedFeatures(state, selectedFeatures) {
    if (!state.selectedFeatures) {
      state.selectedFeatures = [];
    }
    state.selectedFeatures.push(
      ...selectedFeatures.filter(
        proxy1 =>
        !state.selectedFeatures.some(
          proxy2 => proxy2.__value == proxy1.__value
        )
      )
    );
  },
  removeCurrentSelectedFeatures(state, selectedFeatures) {
    if (!state.selectedFeatures) {
      state.selectedFeatures = [];
    }

    _.each(selectedFeatures, (proxy1) => {
      const idx = _.findIndex(state.selectedFeatures, (proxy2) => proxy2.__value == proxy1.__value);
      if (idx >= 0)
        state.selectedFeatures.splice(idx, 1);
    });
  },

  setEditionOn(state, value) {
    state.editionOn = value;
  },
  setTableDataActive(state, value) {
    state.tableDataActive = value;
  },
  setSnapTolerance(state, value) {
    state.snapTolerance = value;
    localStorage.snaptolerance = JSON.stringify(value);
  },
  setSnapLayers(state, value) {
    state.snapLayers = value;
    localStorage.snaplayers = JSON.stringify(value);
  },

  //folders
  setFolders(state, folders) {
    state.folders = folders;
  },
  setFolderData(state, folderData) {
    state.folderData = folderData;
  },
  setCurrentFolderArea(state, folderArea) {
    state.currentFolderArea = folderArea;
  },
  // attachments
  setAttachments(state, attachments) {
    state.attachments = attachments;
  },
  setObjectAttachments(state, attachArr) {
    state.objectAttachments = attachArr;
  },

  setCurrentEditedObject(state, currentEditedObject) {
    state.currentEditedObject = currentEditedObject;
  },
  //events
  setFeatureEvents(state, featureEvents) {
    state.featureEvents = featureEvents;
  },
  //schedules
  setSchedules(state, schedules) {
    state.schedules = schedules;
  },
  //tasks
  setTasks(state, tasks) {
    state.tasks = tasks;
  },
  setTask(state, task) {
    state.task = task;
  },
  setTaskMaterials(state, taskMaterials) {
    state.taskMaterials = taskMaterials;
  },
  // servitudes
  setServitudes(state, servitudes) {
    state.servitudes = servitudes;
  },
  setServitudeData(state, servitudeData) {
    state.servitudeData = servitudeData;
  },
  setAnalysisResult(state, analysisResult) {
    state.analysisResult = analysisResult;
  },
  setServitudeAdding(state, isServitudeAdding) {
    state.isTransmissionEasementAdding = isServitudeAdding;
  },
  //variances
  setVariancesList(state, variancesList) {
    state.variancesList = variancesList;
  },
  setVariancesStatus(state, variancesStatus) {
    state.variancesStatus = variancesStatus;
  },
  setVariancesType(state, variancesType) {
    state.variancesType = variancesType;
  },
  setCurrentVariance(state, variance) {
    state.currentVariance = variance;
  },
  setCurrentVarianceArea(state, varianceArea) {
    state.currentVarianceArea = varianceArea;
  },
  setCurrentAddingVariance(state, variance) {
    state.currentAddingVariance = variance;
  },
  // settings
  setUsers(state, users) {
    state.users = users;
    state.usersMap = _(users).keyBy('id').mapValues('name').value();
  },
  setEvents(state, events) {
    state.events = events;
  },
  setEventUser(state, user) {
    state.eventUser = user;
  },
  setSettings(state, settings) {
    state.settings = settings;
  },
  setCurrentUserGroup(state, group) {
    state.currentUserGroup = group;
  },
  setCurrentUsername(state, username) {
    state.currentUsername = username;
  },
  // SCADA
  setScadaPoints(state, pointsObj) {
    state.scadaPoints.push(pointsObj);
  },
  setCurrentScadaPoint(state, scadaPoint) {
    state.currentScadaPoint = scadaPoint;
  },
  setScadaInterval(state, value) {
    state.scadaInterval = value;
    localStorage.scadaInterval = value;
  },
  setScadaFeaturesArr(state, arr) {
    state.scadaFeaturesArr = arr;
  },
  setNewScadaFeature(state, el) {
    state.scadaFeaturesArr.push(el);
  },
  setScadaLastUpdate(state, val) {
    state.lastScadaUpdate = val;
  },
  // FAILURES
  setFailures(state, failures) {
    state.failures = failures;
  },
  setCurrentFailure(state, currentFailure) {
    state.currentFailure = currentFailure;
  },
  // Refurubishments / repairs
  setRefurbishments(state, refurbishments) {
    state.refurbishments = refurbishments;
  },
  setCurrentRefurbishment(state, currentRefurbishment) {
    state.currentRefurbishment = currentRefurbishment;
  },
  // Costs
  setFailureCosts(state, failureCosts) {
    state.failureCosts = failureCosts;
  },
  setRefurbishmentCosts(state, refurbishmentCosts) {
    state.refurbishmentCosts = refurbishmentCosts;
  },
  setTaskCosts(state, taskCosts) {
    state.taskCosts = taskCosts;
  },
  // Video 
  setVideoInspectionCards(state, videoInspectionCards) {
    state.videoInspectionCards = videoInspectionCards;
  },
  setVideoInspectionCard(state, videoInspectionCard) {
    state.videoInspectionCard = videoInspectionCard;
  },
  setCurrentVideo(state, currentVideo) {
    state.currentVideo = currentVideo;
  },
  //delete layer
  deleteLayerInstance(state, type) {
    Vue.delete(state.layersInstance, type);
  },
  deleteLayer(state, type) {
    _.remove(state.layers, (layer) => layer.full_type === type);
  },
  deleteUserLayer(state, table) {
    _.remove(state.userLayers, (layer) => layer.table === table);
  },
  deleteUserRasterLayer(state, id) {
    _.remove(state.userRasterLayers, (layer) => layer.id === id);
  },
  deleteSketche(state, id) {
    _.remove(state.sketches, (sketche) => sketche.id === id);
  },
  deleteWMSLayer(state, id) {
    _.remove(state.wmsLayers, (layer) => layer.id === id);
  },
  deleteTempLayer(state, props) {
    _.remove(state.tempLayers, (layer) => layer.name === props.name && layer.id === props.id);
  },

  incrementGenerateID(state) {
    state.generateID++;
  },

  // Modelowanie wodociągowe modelWat
  setIncludeReceivers(state, included) {
    state.includeReceiver = included;
    localStorage.includeReceiver = included;
  },
  setModelWatDisplaySettings(state, settings) {
    Vue.set(state, 'modelWatDisplaySettings', settings);
    localStorage.modelWatLegend = JSON.stringify(settings.legend);
  },
  setModelWatTimeStep(state, timeStep) {
    state.modelWatTimeStep = timeStep;
  },

  setVirtualRecipients(state, virtualRecipients) {
    state.virtualRecipients = virtualRecipients;
  },
  setVirtualRecipient(state, virtualRecipient) {
    state.virtualRecipient = virtualRecipient;
  },

  //Hydranet
  setHydraNetWatermeters(state, hydraNetWatermeters) {
    state.hydraNetWatermeters = hydraNetWatermeters;
  },
  setWatermeters(state, watermeters) {
    state.watermeters = watermeters;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js